import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-booster-plays',
  templateUrl: './booster-plays.component.html',
  styleUrls: ['./booster-plays.component.scss']
})
export class BoosterPlaysComponent implements OnInit {
  @Input() game: string;
  @Input() lang: string;

  lolVideoId;
  lolVideoTitle;
  requestDone = false;

  miniTitle = {
    en: {
      cs2: 'The Latest Counter Strike 2 Videos',
      apex: 'The Latest Apex Legends Videos',
      valorant: 'The Latest Valorant Videos',
      lol: 'The Latest League of Legends Videos',
      tft: 'The Latest Teamfight Tactics Videos',
      'wild-rift': 'The Latest Wild Rift Videos',
      marvel: 'The Latest Marvel Rivals Videos',
    },
    fr: {
      cs2: 'Les dernières vidéos Counter Strike 2',
      apex: 'Les dernières vidéos Apex Legends',
      valorant: 'Les dernières vidéos Valorant',
      lol: 'Les dernières vidéos League of Legends',
      tft: 'Les dernières vidéos Teamfight Tactics',
      'wild-rift': 'Les dernières vidéos Wild Rift',
      marvel: 'Les dernières vidéos Marvel Rivals',
    },
    de: {
      cs2: 'Die neuesten Counter Strike 2 Videos',
      apex: 'Die neuesten Apex Legends Videos',
      valorant: 'Die neuesten Valorant Videos',
      lol: 'Die neuesten League of Legends Videos',
      tft: 'Die neuesten Teamfight Tactics Videos',
      'wild-rift': 'Die neuesten Wild Rift Videos',
      marvel: 'Die neuesten Marvel Rivals Videos',
    },
    pt: {
      cs2: 'Os Últimos Vídeos de Counter Strike 2',
      apex: 'Os Últimos Vídeos de Apex Legends',
      valorant: 'Os Últimos Vídeos de Valorant',
      lol: 'Os Últimos Vídeos de League of Legends',
      tft: 'Os Últimos Vídeos de Teamfight Tactics',
      'wild-rift': 'Os Últimos Vídeos de Wild Rift',
      marvel: 'Os Últimos Vídeos de Marvel Rivals',
    },
    es: {
      cs2: 'Vídeos más recientes de Counter Strike 2',
      apex: 'Vídeos más recientes de Apex Legends',
      valorant: 'Vídeos más recientes de Valorant',
      lol: 'Vídeos más recientes de League of Legends',
      tft: 'Vídeos más recientes de Teamfight Tactics',
      'wild-rift': 'Vídeos más recientes de Wild Rift',
      marvel: 'Vídeos más recientes de Marvel Rivals',
    }
  };

  title = {
    howTo: {
      en:'How to purchase your service',
      fr:'Comment acheter votre service',
      de:'So kaufst du deinen Service',
      pt:'Como comprar o serviço',
      es:'Cómo comprar tu servicio'
    },
    play: {
      en: 'Plays Of The Week',
      fr: 'Les Coups de la Semaine',
      de: 'Spiele Der Woche',
      pt: 'Jogadas Da Semana',
      es: 'Jugadas de la Semana'
    },
  };

  description = {
    en: {
      cs2: 'Discover how to purchase the best Counter Strike 2 service for you with this step by step guide.',
      apex: 'Discover how to purchase the best Apex Legends service for you with this step by step guide.',
      valorant: 'Every week we put together our Booster\'s Best Plays',
      lol: 'Every week we put together our Booster\'s Best Plays',
      tft: 'Discover how to purchase the best TFT service for you with this step by step guide.',
      'wild-rift': 'Discover how to purchase the best Wild Rift service for you with this step by step guide.',
      marvel: 'Discover how to purchase the best Marvel Rivals service for you with this step by step guide.',
    },
    fr: {
      cs2: 'Découvrez comment acheter le meilleur service Counter Strike 2 pour vous avec un guide étape par étape.',
      apex: 'Découvrez comment acheter le meilleur service Apex pour vous avec un guide étape par étape.',
      valorant: 'Chaque semaine, nous présentons les meilleurs actions de nos Boosters.',
      lol: 'Chaque semaine, nous présentons les meilleurs actions de nos Boosters.',
      tft: 'Découvrez comment acheter le meilleur service TFT pour vous avec ce guide étape par étape.',
      'wild-rift': 'Découvrez comment acheter le meilleur service Wild Rift pour vous avec un guide étape par étape.',
      marvel: 'Découvrez comment acheter le meilleur service Marvel Rivals pour vous avec ce guide étape par étape.'
    },
    de: {
      cs2: 'Finde heraus, wie du den besten Counter Strike 2 Service für dich kaufen kannst, indem du diese Schritt-für-Schritt-Anleitung verwendest.',
      apex: 'Finde heraus, wie du den besten Apex Legends Service für dich kaufen kannst, indem du diese Schritt-für-Schritt-Anleitung verwendest.',
      valorant: 'Jede Woche stellen wir unsere Booster\'s Best Plays zusammen',
      lol: 'Jede Woche stellen wir die besten Spielzüge unserer Booster zusammen.',
      tft: 'Finde heraus, wie du den besten TFT-Dienst für dich findest, indem du diese Schritt-für-Schritt-Anleitung verwendest.',
      'wild-rift': 'Finde heraus, wie du den besten Wild Rift Service für dich kaufen kannst, indem du diese Schritt-für-Schritt-Anleitung verwendest.',
      marvel: 'Finde heraus, wie du den besten Marvel Rivals Service für dich kaufen kannst, indem du diese Schritt-für-Schritt-Anleitung verwendest.'
    },
    pt: {
      cs2: 'Descobre como comprar o melhor serviço de Counter Strike 2 com este simples tutorial.',
      apex: 'Descobre como comprar o melhor serviço de Apex Legends neste tutorial.',
      valorant: 'Todas as semanas juntamos as Melhores Jogadas dos nossos Boosters.',
      lol: 'Todas as semanas juntamos as Melhores Jogadas dos nossos Boosters.',
      tft: 'Descobre como comprar o melhor serviço de TFT com este tutorial.',
      'wild-rift': 'Descubra como comprar o melhor serviço de Wild Riftneste tutorial.',
      marvel: 'Descobre como comprar o melhor serviço de Marvel Rivals neste tutorial.'
    },
    es: {
      cs2: 'Descubre cómo comprar el mejor servicio de Counter Strike 2 para ti con esta guía paso a paso.',
      apex: 'Descubre cómo comprar el mejor servicio de Apex Legends para ti con esta guía paso a paso.',
      valorant: 'Cada semana recopilamos las mejores jugadas de Booster.',
      lol: 'Cada semana reunimos las mejores jugadas de nuestros boosters.',
      tft: 'Descubre cómo adquirir el mejor servicio TFT para ti con esta guía paso a paso.',
      'wild-rift': 'Descubre cómo adquirir el mejor servicio de Wild Rift para ti con esta guía paso a paso.',
      marvel: 'Descubre cómo adquirir el mejor servicio de Marvel Rivals para ti con esta guía paso a paso.'
    }
  };

  description2 = {
    en: {
      valorant: 'Check out below what to expect from our Top Tier Valorant Boosters',
      lol: 'Check out below what to expect from our Top Tier League of Legends Boosters',
    },
    fr: {
      valorant: 'Découvrez ci-dessous ce que vous pouvez attendre de nos meilleurs Boosters Valorant.',
      lol: 'Découvrez ci-dessous ce que vous pouvez attendre de nos meilleurs Boosters League of Legends.',
    },
    de: {
      valorant: 'Schau dir unten an, was du von unseren Top Tier Valorant Boostern erwarten kannst',
      lol: 'Schau dir unten an, was du von unseren Top Tier League of Legends Boostern erwarten kannst'
    },
    pt: {
      valorant: 'Vê abaixo o que esperar dos nossos Boosters de Valorant',
      lol: 'Vê abaixo o que esperar dos nossos Boosters de League of Legends'
    },
    es: {
      valorant: 'Echa un vistazo a lo que puedes esperar de nuestros Boosters Valorant de primer nivel',
      lol: 'Echa un vistazo a lo que puedes esperar de nuestros Boosters League of Legends de primer nivel'
    }
  };

  constructor(private http: HttpClient, private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    if (this.game === 'valorant' || this.game === 'lol') {
      this.http.get('/weekly-videos/' + this.game).subscribe((video: any) => {
        this.lolVideoId = video.url;
        this.lolVideoTitle = video.title;
        this.requestDone = true;
        this.cdRef.detectChanges();
      });
    } else {
      this.lolVideoId = '1fHLG90CQ5U';
      this.lolVideoTitle = 'GGBoost Video Tutorial';
      this.requestDone = true;
      this.cdRef.detectChanges();
    }
  }
}